// extracted by mini-css-extract-plugin
module.exports = {"page":"Lj","modal":"Mj","actions":"Nj","step":"Oj","primary":"Pj","disabled":"Qj","cancel":"Rj","modalOpenBodyStyle":"Sj","logos":"Tj","primeLogo":"Uj","vipLogo":"Vj","plus":"Wj"};